if (!customElements.get("ingredient-glossary")) {
  const IngredientGlossary = class extends HTMLElement {
    constructor() {
      super();

      this.rtl = document.dir === 'rtl';
      this.sectionId = this.dataset.sectionId
      this.ingredientList = this.querySelector(".ingredient-list");
      this.filter = this.querySelector(".ingredient-filter");
      this.prevBtn = this.querySelector('button[name="prev"]');
      this.nextBtn = this.querySelector('button[name="next"]');
      this.nav = this.querySelector('.ingredient-nav');

      // enable scroll
      this.scrollHandler = debounce(this.handleScroll.bind(this), 100);
      this.filter.addEventListener('scroll', this.scrollHandler);
      this.handleScroll();

      // enable drag scrolling
      if (window.matchMedia('(pointer: fine)').matches) {
        this.filter.classList.add('is-grabbable');
        this.mousedownHandler = this.handleMousedown.bind(this);
        this.mouseupHandler = this.handleMouseup.bind(this);
        this.mousemoveHandler = this.handleMousemove.bind(this);
  
        this.filter.addEventListener('mousedown', this.mousedownHandler);
        this.filter.addEventListener('mouseup', this.mouseupHandler);
        this.filter.addEventListener('mouseleave', this.mouseupHandler);
        this.filter.addEventListener('mousemove', this.mousemoveHandler);
        // this.slider.addEventListener('dragstart', (evt) => { evt.preventDefault(); }); 
      }

      // enable nav click

      // Distance between leading edges of adjacent letters (i.e. width of letter + gap).
      this.slideSpan = this.getWindowOffset(this.querySelector('.slider__item:nth-child(3)')) - this.getWindowOffset(this.querySelector('.slider__item:nth-child(2)'));

      // Distance between leading edges of TOP and first letter
      this.slideSpanTop = this.getWindowOffset(this.querySelector('.slider__item:nth-child(2)')) - this.getWindowOffset(this.querySelector('.slider__item:nth-child(1)'));

      this.navClickHandler = this.handleNavClick.bind(this);
      this.nav.addEventListener('click', this.navClickHandler);

    }

    connectedCallback() {
      theme.addDelegateEventListener(this, 'click', '.slider__item', this.selectFilter.bind(this));
    }
    
    disconnectedCallback() {
      this.filter.removeEventListener('scroll', this.scrollHandler);

      if (window.matchMedia('(pointer: fine)').matches) {
        this.filter.removeEventListener('mousedown', this.mousedownHandler);
        this.filter.removeEventListener('mouseup', this.mouseupHandler);
        this.filter.removeEventListener('mouseleave', this.mouseupHandler);
        this.filter.removeEventListener('mousemove', this.mousemoveHandler);
      }

      this.nav.removeEventListener('click', this.navClickHandler);
    }

    handleMousedown(evt) {
      this.mousemoved = false;
      this.filter.classList.add('is-grabbing');
      this.filterStart = this.getWindowOffset(this.filter);
      this.startX = evt.pageX - this.filterStart;
      this.scrollPos = this.filter.scrollLeft;
    }

    handleMouseup() {
      this.filter.classList.remove('is-grabbing');
      if (this.mousemoved) {
        // evt.preventDefault();
        this.filter.classList.remove('is-dragging');
      }  
    }

    handleMousemove(evt) {
      if (!this.filter.classList.contains('is-grabbing')) return;
      evt.preventDefault();

      const x = evt.pageX - this.filterStart;
      const walk = (x - this.startX) * 2; //scroll-fast
      this.filter.scrollLeft = this.scrollPos - walk;

      this.mousemoved = true;
      this.filter.classList.add('is-dragging');
    }
    
    handleScroll() {
      // Handle scroll event
      const scrollableNextClass = 'scrollable-next';
      const isScrollableToRight = Math.ceil(this.filter.scrollLeft) < (this.filter.scrollWidth - this.filter.clientWidth);

      if (isScrollableToRight) {
        this.filter.classList.add(scrollableNextClass);    
      } else {
        this.filter.classList.remove(scrollableNextClass);
      }
      this.nextBtn.disabled = !isScrollableToRight;

      const scrollablePrevClass = 'scrollable-prev';
      const isScrollableToLeft = this.filter.scrollLeft > 0;
      if (isScrollableToLeft) {
        this.filter.classList.add(scrollablePrevClass);
      } else {
        this.filter.classList.remove(scrollablePrevClass);
      }
      this.prevBtn.disabled = !isScrollableToLeft;

    }

    selectFilter(evt, delEl) {
      const filterUrl = delEl.href;

      if (filterUrl) {
        evt.preventDefault();

        // cancel current request if one exists
        if (this.abortController) {
          this.abortController.abort();
        }
        this.abortController = new AbortController();

        // fetch new ingredient list
        fetch(filterUrl + `&section-id=${this.sectionId}`, {
          method: 'get',
          signal: this.abortController.signal
        })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.text();
        })
        .then(response => {
          const tmpl = document.createElement('template');
          tmpl.innerHTML = response;
          const newIngredientList = tmpl.content.querySelector('.ingredient-list');
          this.ingredientList.innerHTML = newIngredientList.innerHTML;
          
          // set new filter as active
          this.filter.querySelector('.active')?.classList.remove('active');
          delEl.classList.add('active');
        });
      }
    }

    getWindowOffset(el) {
      return this.rtl
        ? window.innerWidth - el.getBoundingClientRect().right
        : el.getBoundingClientRect().left;
    }

    handleNavClick(evt) {

      if (!evt.target.matches('.ingredient-nav__btn')) return;

      if ((evt.target.name === 'next' && !this.rtl) || (evt.target.name === 'prev' && this.rtl)) {
        if (this.filter.scrollLeft == 0) {
          // The slide span of TOP can be different from the rest of the letters - e.g. Japanese word
          this.scrollPos = this.filter.scrollLeft + this.slideSpanTop;
        } else {
          this.scrollPos = this.filter.scrollLeft + this.slideSpan;
        }
      } else {
        if (this.filter.scrollLeft == 0) {
          this.scrollPos = this.filter.scrollLeft - this.slideSpanTop;
        } else {
          this.scrollPos = this.filter.scrollLeft - this.slideSpan;
        }
      }
  
      this.filter.scrollTo({ left: this.scrollPos, behavior: 'smooth' });
  
    }
    
  };
  
  window.customElements.define("ingredient-glossary", IngredientGlossary);
}
